import React, { useState } from 'react';
import { COLORS } from '../config/constants';

const SendMailModal = ({ isOpen, onClose, onSend, moduleName }) => {
  const [recipients, setRecipients] = useState('');
  const [attachExcel, setAttachExcel] = useState(true);
  const [attachPdf, setAttachPdf] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Parse email addresses
    const emailList = recipients
      .split(/[,;\s]+/)
      .map(email => email.trim())
      .filter(email => email.length > 0);
    
    if (emailList.length === 0) {
      alert('Lütfen en az bir mail adresi girin!');
      return;
    }

    if (!attachExcel && !attachPdf) {
      alert('Lütfen en az bir dosya formatı seçin (Excel veya PDF)!');
      return;
    }

    setSending(true);
    try {
      await onSend(emailList, attachExcel, attachPdf);
      // Reset form
      setRecipients('');
      setAttachExcel(true);
      setAttachPdf(false);
      onClose();
    } catch (error) {
      // Error handled by parent
    } finally {
      setSending(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#FFFFFF',
        borderRadius: '16px',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <h2 style={{ 
          color: COLORS.primary, 
          marginBottom: '1.5rem',
          fontSize: '1.5rem'
        }}>
          📧 {moduleName} Raporu Gönder
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
              Alıcı Mail Adresleri *
            </label>
            <textarea
              value={recipients}
              onChange={(e) => setRecipients(e.target.value)}
              placeholder="mail1@ornek.com, mail2@ornek.com&#10;Virgül, noktalı virgül veya satır ile ayırabilirsiniz"
              required
              rows={4}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #E8E8E8',
                borderRadius: '8px',
                fontSize: '0.95rem',
                fontFamily: 'inherit',
                resize: 'vertical'
              }}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.75rem', fontWeight: '500' }}>
              Ek Dosya Formatları *
            </label>
            
            <label style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '0.5rem', 
              marginBottom: '0.5rem',
              cursor: 'pointer',
              padding: '0.75rem',
              background: attachExcel ? '#E7F5EC' : '#F9FAFB',
              borderRadius: '8px',
              border: `2px solid ${attachExcel ? '#10B981' : '#E8E8E8'}`
            }}>
              <input
                type="checkbox"
                checked={attachExcel}
                onChange={(e) => setAttachExcel(e.target.checked)}
                style={{ width: '18px', height: '18px' }}
              />
              <span>📊 Excel Dosyası (.xlsx)</span>
            </label>

            <label style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '0.5rem',
              cursor: 'pointer',
              padding: '0.75rem',
              background: attachPdf ? '#FEE2E2' : '#F9FAFB',
              borderRadius: '8px',
              border: `2px solid ${attachPdf ? '#E40A04' : '#E8E8E8'}`
            }}>
              <input
                type="checkbox"
                checked={attachPdf}
                onChange={(e) => setAttachPdf(e.target.checked)}
                style={{ width: '18px', height: '18px' }}
              />
              <span>📄 PDF Dosyası (.pdf)</span>
            </label>
          </div>

          <div style={{
            padding: '1rem',
            background: '#F3F4F6',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            fontSize: '0.875rem',
            color: '#666'
          }}>
            <p style={{ margin: 0 }}>
              ℹ️ Seçili filtreler varsa, mail içeriğinde gösterilecek ve sadece filtrelenmiş kayıtlar gönderilecektir.
            </p>
          </div>

          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={sending}
              style={{
                padding: '0.75rem 1.5rem',
                background: '#FFFFFF',
                color: '#666',
                border: '2px solid #E8E8E8',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '500',
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.5 : 1
              }}
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={sending}
              style={{
                padding: '0.75rem 1.5rem',
                background: 'linear-gradient(135deg, #E40A04 0%, #B00803 100%)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.6 : 1
              }}
            >
              {sending ? '📧 Gönderiliyor...' : '📧 Gönder'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SendMailModal;
